export default __webpack_public_path__ + "39ee2d712fcf7a49c8eb95aaeca059a9.svg";